import { useState } from 'react';
import emailjs from '@emailjs/browser';


const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateMessage, setStateMessage] = useState(null);
  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          setStateMessage('Message sent!');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        },
        (error) => {
          setStateMessage('Something went wrong, please try again later');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        }
      );
    
    // Clears the form after sending the email
    e.target.reset();
  };
  return (
    <div className='contactform'>
      <form onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" style={{ padding:'0.5rem 0'}}/>
      <label>Email</label>
      <input type="email" name="user_email" style={{ padding:'0.5rem 0'}}/>
      <label>Message</label>
      <textarea name="message" style={{ padding:'0.5rem 0'}}/>
      <input className='form-submit' type="submit" value="Send" disabled={isSubmitting} />
      {stateMessage && <p>{stateMessage}</p>}
    </form>
    </div>
    
  );
};
export default ContactForm;
